import HandLikeIcon from "../images/HandLikeIcon.mjs";

/**
 * App icon for "true" (successful) boolean values, highlighted in success color
 * @see {GlyphIcon}
 * @see {HandLikeIcon}
 */
const AppFlagTrueIcon = class extends HandLikeIcon {
	constructor(props) {
		super(props);
		this.state.fill = "var(--ok-color)";
	}
}

export default AppFlagTrueIcon;